export const allGoodbyes = [
  "Bye bye!",
  "I'll see later maybe. Or not, whatever.",
  "Goodbye!",
  "K, bye",
  "See ya!",
  "Buh bye",
  "Keep it sleazy!",
  "See you later!",
  "Bye bye bye...",
  "OK, bye bye",
  "OK, I'll see you later"
]